<template>
  <v-select
    :value="value"
    :items="options"
    item-text="label"
    item-value="value"
    :label="label"
    :outlined="outlined"
    :dense="dense"
    :hide-details="hideDetails"
    :disabled="disabled"
    @change="onChange"
  >
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center">
        <span class="k-flag">{{ item.flag }}</span>
        <span>{{ item.label }}</span>
      </div>
    </template>

    <template v-slot:item="{ item }">
      <div class="d-flex align-center">
        <span class="k-flag">{{ item.flag }}</span>
        <span>{{ item.label }}</span>
      </div>
    </template>
  </v-select>
</template>

<script>
import { getSupportedLocales, setAppLocale } from "@/i18n";

const FLAG_BY_LOCALE = {
  es: "🇪🇸",
  en: "🇬🇧",
  pt: "🇵🇹"
};

export default {
  name: "LanguageSelector",
  props: {
    value: { type: String, default: "es" },
    label: { type: String, default: "" },
    dense: { type: Boolean, default: true },
    outlined: { type: Boolean, default: true },
    hideDetails: { type: [Boolean, String], default: "auto" },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    options() {
      return getSupportedLocales().map((locale) => ({
        value: locale,
        label: this.$t(`languages.${locale}`),
        flag: FLAG_BY_LOCALE[locale] || "🌐"
      }));
    }
  },
  methods: {
    onChange(locale) {
      setAppLocale(locale);
      this.$emit("input", locale);
      this.$emit("change", locale);
    }
  }
};
</script>

<style scoped>
.k-flag {
  width: 1.6rem;
  margin-right: 8px;
  display: inline-flex;
  justify-content: center;
}
</style>
